import { Component, OnInit } from '@angular/core';
import { ContratoDashboard, ContratoDashboardLinha } from '../../../core/models/contratos/contrato';
import { ContratoService } from '../../../core/services/contratos/contrato.service';

@Component({
  standalone: false,
  selector: 'app-dashboard-contratos',
  templateUrl: './dashboard-contratos.component.html',
  styleUrls: ['./dashboard-contratos.component.css']
})
export class DashboardContratosComponent implements OnInit {
  dashboard: ContratoDashboard = { contratos_ativos: 0, linhas: [], meta_mes_atual: 0, realizado_mes_atual: 0, atingimento_mes_atual: 0 };
  status = 'ATIVO';
  clienteFiltro = '';
  vendedorFiltro = '';
  resultadoFiltro = '';
  contratoExpandido: { [key: string]: boolean } = {};
  carregando = false;
  usa_contrato = false;

  constructor(private contratoService: ContratoService) { }

  ngOnInit() {
    this.usa_contrato = localStorage.getItem('usa_contrato') === 'true';

    if (this.usa_contrato) {
      this.carregar();
    }
  }

  carregar() {
    this.carregando = true;
    this.contratoService.getDashboard({ status: this.status }).subscribe((dashboard) => {
      this.dashboard = dashboard || { contratos_ativos: 0, linhas: [], meta_mes_atual: 0, realizado_mes_atual: 0, atingimento_mes_atual: 0 };
      this.carregando = false;
    });
  }

  get vendedores(): string[] {
    const nomes = (this.dashboard.linhas || [])
      .map((linha) => linha.vendedor_nome || 'Sem vendedor')
      .filter((nome, index, lista) => lista.indexOf(nome) === index);

    return nomes.sort();
  }

  get linhasFiltradas(): ContratoDashboardLinha[] {
    return (this.dashboard.linhas || []).filter((linha) => {
      const clienteFiltro = (this.clienteFiltro || '').toLowerCase().trim();
      const cliente = (linha.cliente_nome || '').toLowerCase();
      const erp = (linha.codigo_no_erp_do_cliente || '').toLowerCase();
      const vendedor = linha.vendedor_nome || 'Sem vendedor';
      const atingido = (linha.atingimento_mes_atual || 0) >= 100;

      if (clienteFiltro && cliente.indexOf(clienteFiltro) < 0 && erp.indexOf(clienteFiltro) < 0) {
        return false;
      }

      if (this.vendedorFiltro && vendedor !== this.vendedorFiltro) {
        return false;
      }

      if (this.resultadoFiltro === 'ATINGIDO' && !atingido) {
        return false;
      }

      if (this.resultadoFiltro === 'NAO_ATINGIDO' && atingido) {
        return false;
      }

      return true;
    });
  }

  alternarDetalhes(linha: ContratoDashboardLinha) {
    const chave = this.chaveLinha(linha);
    this.contratoExpandido[chave] = !this.contratoExpandido[chave];
  }

  estaExpandido(linha: ContratoDashboardLinha): boolean {
    return !!this.contratoExpandido[this.chaveLinha(linha)];
  }

  mesAtual(linha: ContratoDashboardLinha) {
    if (!linha || !linha.meses || linha.meses.length === 0) {
      return null;
    }

    return linha.meses[linha.meses.length - 1];
  }

  labelMes(mes: any): string {
    if (!mes || !mes.mes) {
      return 'MES --';
    }

    const data = new Date(mes.mes);
    const numeroMes = data.getMonth() + 1;
    return 'MES ' + (numeroMes < 10 ? '0' + numeroMes : numeroMes);
  }

  statusContrato(linha: ContratoDashboardLinha): string {
    return (linha.atingimento_mes_atual || 0) >= 100 ? 'Atingido' : 'Nao atingido';
  }

  classePercentual(percentual: number): string {
    if (percentual >= 100) {
      return 'ok';
    }

    if (percentual >= 70) {
      return 'alerta';
    }

    return 'risco';
  }

  largura(percentual: number): string {
    const valor = Math.max(0, Math.min(100, percentual || 0));
    return valor + '%';
  }

  trackLinha(index: number, linha: ContratoDashboardLinha): string {
    return this.chaveLinha(linha);
  }

  private chaveLinha(linha: ContratoDashboardLinha): string {
    return linha.contrato_id + '-' + linha.product_id;
  }
}
